import React from 'react'
import {useIntl} from 'react-intl'

import {Text} from '@vio/atlas/Text'

import {CashbackMessageProps} from '../../../types/cashback'

export const CashbackKarmaText = ({
  value,
  variant,
  messages
}: CashbackMessageProps) => {
  const {formatMessage, formatNumber} = useIntl()
  return (
    <Text variant="labelXS" tag="span" colorPath="content.brand.primary">
      {variant === 'long'
        ? formatMessage(messages.cashbackLongMessage!, {
            value: formatNumber(value / 100, {style: 'percent'})
          })
        : formatMessage(messages.cashbackShortMessage!, {
            value: formatNumber(value / 100, {style: 'percent'})
          })}
    </Text>
  )
}
